import React from 'react';

import {useFormContext} from 'react-hook-form';
import {useSelector} from 'react-redux';

import {AddressFormType} from 'desktop/types/addressType';

import {getSaveAddressErrorMessage} from '../../store/selectors/deliveryStep/deliveryStep';

import s from './deliveryStepError.scss';

/**
 * Delivery step error
 */
export const DeliveryStepError: React.FC = () => {
    const deliveryStepError = useSelector(getSaveAddressErrorMessage);
    const {getFieldState} = useFormContext<AddressFormType>();

    const isPostalError =
        getFieldState('shippingAddress.postal').invalid ||
        getFieldState('billingAddress.postal').invalid;

    const errorMessage = deliveryStepError || (isPostalError && 'Invalid Zip code');

    if (!errorMessage) return null;

    return <p className={s.deliveryStepError}>{errorMessage}</p>;
};
